import Table from './Table';

module.exports = Table;



// WEBPACK FOOTER //
// ./src/index.js